import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';
import { useGetConfigQuery } from '../services/config-api.service';

export const RequireConfig = () => {
  const { showBoundary } = useErrorBoundary();
  const { data: config, error } = useGetConfigQuery();

  useEffect(() => {
    if (!error || error.status === 401) return;

    console.error('Le fichier de configuration n\'a pas pu être chargé.');
    showBoundary(error.error || error.message || error);
  }, [error]);

  return (config) ? <Outlet /> : <></>;
};